<template>
  <b-modal
    id="version-modal"
    size="md"
    v-model="showPrompt"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    hide-header
    hide-footer
  >
    <div slot="default">
      <div class="row no-gutters Hometitle">
        <div class="col-sm-12">
          <h4><small class="text-muted"><strong>New Version Available :</strong></small></h4>
        </div>
      </div>
      <div class="alert alert-warning" role="alert">
        A new version is available. <b>Refresh now</b> to continue with the latest version. Unsaved changes will be lost. Click <b>Later</b> to save your work and refresh later.
      </div>
      <div class="row no-gutters">
        <div class="col-sm-12 text-right">
          <b-button variant="secondary" class="mr-2" @click="dismiss">Later</b-button>
          <b-button variant="primary" @click="reload">Refresh now</b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { isOutOfDate } from "@/Common/VersionCheck";

const CHECK_INTERVAL = 5 * 60 * 1000; //every 5 minutes check will fire
// const CHECK_INTERVAL = 10 * 1000; //every 10 seconds this check will fire use this value for testing purposes

export default {
  name: "VersionModal",
  data() {
    return {
      showPrompt: false,
      isChecking: false,
      timerId: null
    };
  },
  created() {
    this.timerId = setInterval(this.check, CHECK_INTERVAL);
    document.addEventListener("visibilitychange", this.onVisibilityChange);
    window.addEventListener("focus", this.check);
  },
  beforeDestroy() {
    clearInterval(this.timerId);
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
    window.removeEventListener("focus", this.check);
  },
  methods: {
    onVisibilityChange() {
      if (document.visibilityState === "visible") this.check();
    },
    async check() {
      if (this.isChecking || this.showPrompt) return;
      this.isChecking = true;
      try {
        this.showPrompt = await isOutOfDate();
      } finally {
        this.isChecking = false;
      }
    },
    dismiss() {
      this.showPrompt = false;
    },
    reload() {
      window.location.reload(true);
    }
  }
};
</script>
